"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterIssuesByConfig = exports.isBestPracticeIssue = exports.isSavedIssue = void 0;
const accessibility_standards_1 = require("@deque/accessibility-standards");
function isSavedIssue(issue) {
    return 'id' in issue;
}
exports.isSavedIssue = isSavedIssue;
const includesWcagTag = (tags) => !!(Array.isArray(tags) && tags.find(accessibility_standards_1.validate));
const isBestPracticeIssue = (issue) => {
    const { tags, isBestPractice, isManual } = issue;
    // manual issues are all record issues
    const isManualIssue = isManual && isSavedIssue(issue) && !issue.igtTool;
    // axe-core issues can currently contain both "best-practice" and wcag level tags,
    // for the purpose of identifying wcag issues, we do not want to consider them
    // as best practice if they have any wcag level tags
    // we make an exception for user-raised manual issues
    if (includesWcagTag(tags) && !isManualIssue) {
        return false;
    }
    return isBestPractice || tags?.includes('best-practice');
};
exports.isBestPracticeIssue = isBestPracticeIssue;
function filterIssuesByConfig(issues, configFilters) {
    const matchesRuleset = ({ tags = [] }) => configFilters.configAccessibilityStandard === 'all' ||
        !!tags.filter(tag => 
        // @ts-expect-error - It's okay that the tag does not match, we're just trying to validate that the list of tags is one of the ones in the selected ruleset
        accessibility_standards_1.rulesets[configFilters.configAccessibilityStandard].tags.includes(tag)).length;
    const isBestPracticesEnabled = configFilters.configBestPractices === 'enabled';
    const isAdvancedRulesEnabled = configFilters.configAdvancedRules === 'enabled';
    const isNeedsReviewDisabled = configFilters.configNeedsReview === 'disabled';
    const accessibilityStandard = configFilters.configAccessibilityStandard;
    return issues.filter(issue => (isBestPracticesEnabled || !(0, exports.isBestPracticeIssue)(issue)) &&
        (isAdvancedRulesEnabled || !issue.isAdvanced) &&
        (!isNeedsReviewDisabled || !issue.isNeedsReview) &&
        ((accessibilityStandard && !(0, exports.isBestPracticeIssue)(issue)
            ? matchesRuleset(issue)
            : true) ||
            (accessibilityStandard &&
                accessibilityStandard === 'TTv5' &&
                issue.isManual
                ? true
                : matchesRuleset(issue))));
}
exports.filterIssuesByConfig = filterIssuesByConfig;
//# sourceMappingURL=filter-extension-issues.js.map